export default __webpack_public_path__ + "static/media/embeddeduis.75b451ab.svg";